jQuery(document).ready(function () {
    // Ensure _window is defined
    const _window = window._window || jQuery(window);
    let viewportW = _window.width();
    let viewportH = _window.height();

    // smartresize when resize screen
    if (typeof _window.smartresize === 'function') {
        _window.smartresize(function () {
            viewportW = _window.width();
            viewportH = _window.height();
        });
    } else {
        _window.on('resize', function () {
            viewportW = _window.width();
            viewportH = _window.height();
        });
    }

    // menu smp
    if (viewportW > viewportSMP) {
        const header_scroll_class = '_small';

        // header small
        _window.on('scroll', function () {
            if (_window.scrollTop() > 100) {
                jQuery('#header').addClass(header_scroll_class);
            } else {
                jQuery('#header').removeClass(header_scroll_class);
            }
        });
    }

    // scroll to top
    if (typeof jQuery.fn.toTopButton === 'function') {
        jQuery('body').toTopButton({
            imagePath: (typeof path_media !== 'undefined' ? path_media : '') + 'icons',
            arrowType: 'arrow-l',
            margin: 2,
            size: (typeof is_smp !== 'undefined' && is_smp) ? 2 : 4,
            backgroundColor: '#0A4BB7',
            linkClasses: [' scroll_totop'],
            mobileHide: 0
        });
    }

    // zoom img on SMP
    const smp_zoom = jQuery('.smp_zoom');
    if (
        smp_zoom.length > 0 &&
        typeof viewportSMP !== 'undefined' &&
        viewportW <= viewportSMP
    ) {
        smp_zoom.each(function () {
            const $img = jQuery(this);
            if (!$img.parent('a[data-fancybox]').length) {
                $img.wrap('<a data-fancybox href="' + $img.attr('src') + '"></a>');
            }
        });
    }

    // check element in view
    const in_view = jQuery('[class*="inview-"]');
    if (in_view.length > 0 && typeof in_view.on === 'function') {
        in_view.on('inview', function (event, isInView) {
            if (isInView) {
                jQuery(this).addClass('inview-active');
            }
        });
    }

    // fancybox
    if (typeof Fancybox !== 'undefined' && typeof Fancybox.bind === 'function') {
        Fancybox.bind("[data-fancybox]", {
            // Your custom options
        });
    }

    // main visual
    setTimeout(function () {
        const main_visual = jQuery('.main_visualbox__banner');
        if (main_visual.length > 0) {
            const mainvisual_image = (typeof is_smp !== 'undefined' && is_smp)
                ? main_visual.data('imgsmp')
                : main_visual.data('imgpc');
            if (mainvisual_image) {
                main_visual.css('background-image', 'url(' + mainvisual_image + ')');
            }
        }
    }, 500);
    /* menu smp */
    if (is_smp) {
        var menu_smp = jQuery('.hamburger');
        var menu_content = jQuery('.header_group');

        menu_smp.on('click', function () {
            var $this = jQuery(this);
            var $thisParent = $this.parent();

            $this.toggleClass('is-active');

            $thisParent.toggleClass('parent-active');

            menu_content.toggleClass('is-open');
            jQuery('body').toggleClass('menu-open');
        });
    }else{
        jQuery('.header_navi li.has_child').on('mouseenter', function () {
            jQuery(this).addClass('open');
        }).on('mouseleave', function () {
            jQuery(this).removeClass('open');
        });
    }
});

(function(window, undefined) {
    if (window.cus === undefined) {
        window.cus = {};
    }

    var cus = window.cus;
    window.cus = cus;

    

})(window);


jQuery(function($){

    jQuery(document).on('click', '.file-box', function(e){

        if(!jQuery(e.target).is('input[type=file]')){
            jQuery(this).find('input[type=file]').trigger('click');
        }

    });

    jQuery(document).on('click', '.file-btn', function(e){

        e.stopPropagation();

        jQuery(this)
            .closest('.file-box')
            .find('input[type=file]')
            .trigger('click');

    });

    jQuery(document).on('change', '.file-input', function(){

        let fileName = '選択されていません';

        if(this.files && this.files[0]){
            fileName = this.files[0].name;
        }

        const box = jQuery(this).closest('.file-box');

        box.find('.file-name').text(fileName);

        if(jQuery(this).attr('name') === 'resume_file'){
            jQuery('input[name="resume_filename"]').val(fileName);
        }

        if(jQuery(this).attr('name') === 'career_file'){
            jQuery('input[name="career_filename"]').val(fileName);
        }

    });

});


jQuery(function ($) {

    function runZipAutoFill($container) {
        const $zip = $container.find('.js-zip');
        const $addr = $container.find('.js-address');

        if (!$zip.length || !$addr.length) return;

        $zip.zip2addr({
            pref: $addr,
            addr: $addr
        });

        $zip.trigger('keyup');
    }

    jQuery(document).on('click', '.js-zip-autofill', function () {
        const $container = jQuery(this).closest('dd');
        runZipAutoFill($container);
    });

    jQuery(document).on('input', '.js-zip', function () {
        const $container = jQuery(this).closest('dd');
        $container.find('.js-address').val('');
        jQuery(this).off('keyup.zip2addr');
    });

});

jQuery(function ($) {

    function formatCheckbox() {

        jQuery('._custom_checkbox .wpcf7-list-item').each(function () {

        if (jQuery(this).find('._sub_text').length) return;

        const labelWrap = jQuery(this).find('label');
        const labelText = labelWrap.find('.wpcf7-list-item-label');
        const text = labelText.text().trim();

        const match = text.match(/^(.*?)(（[^（）]*）)$/);

        if (match) {
            const main = match[1];
            const sub = match[2];

            labelText.text(main);

            labelWrap.append(`<span class="_sub_text">${sub}</span>`);
        }

        });

    }

    formatCheckbox();

    document.addEventListener('wpcf7rendered', function () {
        formatCheckbox();
    });

});